import React from "react";
import useAudioContext from "../hooks/audio-context";

const readableTimestamp = (seconds = 0) => {
  const secondsInHour = 3600;
  return new Date(seconds * 1000)
    .toISOString()
    .slice(seconds >= secondsInHour ? 11 : 14, 19);
};

export default function TimestampBox({ timestamp }: { timestamp: string }) {
  const parsedTs = parseFloat(timestamp);
  const audioContext = useAudioContext();
  return (
    <span
      className="w-[60px] mr-2.5 cursor-pointer select-none content-before text-muted-foreground hover:text-foreground"
      data-content={readableTimestamp(parsedTs)}
      onTouchStart={(e) => {
        e.stopPropagation();
        audioContext.seek(Math.floor(parsedTs));
      }}
      onClick={(e) => {
        e.stopPropagation();
        audioContext.seek(Math.floor(parsedTs));
      }}
    />
  );
}
